<div *ngIf="showHeader" class="header">
  <h2 class="headline-5">{{ getFirstNameOrFallback() }}</h2>
  <visana-lib-button
    (click)="remove.emit()"
    *ngIf="index > 0"
    iconName="delete"
    variant="violet-light"
    data-cy="delete"
    data-analytics="person-data_delete-person"
  ></visana-lib-button>
</div>
<div>
  <visana-lib-icon-radio-button-row
    *ngIf="genderOptions$ | async as genderOptions"
    [error]="validatorService.getErrorMessage(personFormGroup.controls.gender, validateForm)"
    [options]="genderOptions"
    [formControl]="personFormGroup.controls.gender"
  ></visana-lib-icon-radio-button-row>
  <visana-lib-date-picker
    #dateOfBirthInputField
    *ngIf="datePickerConfig$ | async as datePickerConfig"
    (clear)="personFormGroup.controls.dateOfBirth.setValue('')"
    (blurEvent)="hideDateValidation = false"
    [placeholderActive]="true"
    data-cy="input-birth-date"
    inputId="dateOfBirth-person-{{ index }}"
    [language]="datePickerConfig.currentLanguage"
    [minDate]="datePickerConfig.minDate"
    [maxDate]="datePickerConfig.maxDate"
    [label]="(isPrenatalSelected() ? 'KEY_DATA.EXPECTED_DATE_OF_BIRTH' : 'COMMON.DATE_OF_BIRTH') | translate"
    [formControl]="personFormGroup.controls.dateOfBirth"
    placeHolder="{{ 'KEY_DATA.EXPECTED_DATE.PATTERN' | translate }}"
    (focusEvent)="hideDateValidation = true"
    [error]="validatorService.getDateOfBirthErrorMessage(personFormGroup, !hideDateValidation && validateForm)"
  >
  </visana-lib-date-picker>
  <visana-lib-form-field
    *ngIf="showNameField"
    (clear)="personFormGroup.controls.firstName.setValue('')"
    data-cy="input-first-name"
    inputId="firstName-person-{{ index }}"
    label="{{ 'KEY_DATA.FIRST_NAME.OPTIONAL' | translate }}"
    [error]="validatorService.getErrorMessage(personFormGroup.controls.firstName, validateForm)"
  >
    <input
      sscCapitalize
      [formControl]="personFormGroup.controls.firstName"
      id="firstName-person-{{ index }}"
      placeholder="{{ 'KEY_DATA.FIRST_NAME.OPTIONAL' | translate }}"
      type="text"
    />
  </visana-lib-form-field>
</div>
